import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BatchesModel } from 'common/models/page-models/Batches/batches-data-model';

import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BatchesFormWidgetService } from 'common/widget/batches/batches-form-widget.services';


@Injectable({
    providedIn: 'root'
})
export class BatchesFormResolver extends FormResolverService<BatchesModel> {
    constructor(
        protected fs: BatchesFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel, meta, widget) {
    //     console.log(dataModel);

    //     if (dataModel.duration_end !== '' && dataModel.duration_start !== '') {
    //         dataModel.duration_end = this.systemService.dateConversionPanVerify(dataModel.duration_end);
    //         dataModel.duration_start = this.systemService.dateConversionPanVerify(dataModel.duration_start);
    //     }

    //     return dataModel;
    // }

    formatDateToYYYYMMDD(input: string): string {
        const date = new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;
        // console.log(formattedDate);
        return formattedDate;
    }
}
